import React from 'react';
import styled from '@emotion/styled';
import { Flex, Box, Image } from '../Rebass';
import flagZA from '../../static/flagZA.png';
import flagUK from '../../static/flagUK.png';
import flagUSA from '../../static/flagUSA.png';
import flagSingapore from '../../static/flagSingapore.png';
import flagBrazil from '../../static/flagBrazil.png';
import { SxStyleProp } from '../Rebass/types';

interface IconProps {
  name?: string;
  size?: number;
  duoColor?: string;
  sx?: SxStyleProp;
}

const StyledIconWrapper = styled(Box)`
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const StyledIcon = styled(Flex)<{ size: number }>`
  display: flex !important;
  font-size: ${({ size }) => size}px !important;
`;

const StyledIconDuo = styled(Box)<{ size: number; duoColor?: string }>`
  font-size: ${({ size }) => size}px !important;
  position: absolute;
  left: 0;
  top: 0;
  :before {
    color: ${({ duoColor }) => duoColor};
  }
`;

const StyledIconLabel = styled.span`
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

const imageMap = {
  'flag-south-africa-image': flagZA,
  'flag-usa-image': flagUSA,
  'flag-brazil-image': flagBrazil,
  'flag-singapore-image': flagSingapore,
  'flag-uk-image': flagUK,
};

const iconType = (name) => {
  if (name.includes('duo')) {
    return 'duo';
  }
  if (name.includes('image')) {
    return 'image';
  }
};

const Icon = ({ name, duoColor, size, sx, ...rest }: IconProps) => {
  return (
    <StyledIconWrapper className="StyledIconWrapper" sx={sx} {...rest}>
      {/* Accessibility purposes (Icons hidden from screen) */}
      <StyledIconLabel className="visually-hidden">{name}</StyledIconLabel>

      {iconType(name) !== 'image' && (
        <StyledIcon
          justifyContent="center"
          data-testid="icon"
          className={`icon icon-${name}`}
          size={size}
        />
      )}
      {iconType(name) === 'duo' && (
        <Box>
          <StyledIconDuo
            data-testid="icon"
            className={`icon icon-${name}-color`}
            size={size}
            duoColor={duoColor}
            sx={sx}
            {...rest}
          />
        </Box>
      )}
      {iconType(name) === 'image' && (
        <Image width={size} src={imageMap[name]} />
      )}
    </StyledIconWrapper>
  );
};

Icon.defaultProps = {
  name: 'close',
  size: 16,
  duoColor: null,
};

export default Icon;
